import {ChangeDetectorRef, Component, ElementRef, OnInit, OnDestroy, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ReferralsService} from '../../configuration/referral-configuration/referrals.service';
import {ReferralPortalAuthenticateResponseModel} from './Models/referralPortalAuthenticateResponse.model';
import {
    DataReferralDoctorsModel, emailReferralPortalInformationModel, ReferralDataModel,
    TDOReferringDataDoctorModel
} from '../../configuration/referral-configuration/models/referral-data.model';
import {
    ReferringDoctorQueryOptionsModel
} from '../../../models/doctors/doctor-query-options.model';
import {ReferringDoctorDataModel} from '../../configuration/referral-configuration/models/referring-doctor-data.model';
import {FormBuilder} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {LabelResponseModel} from '../../../models/labels/label-response.model';
import {DocumentDataImageModel} from '../../../main-interface/controls/tdo-organizer/models/document-data-image.model';
import {SystemTaskDataModel} from '../../../models/messaging/system-task-data.model';
import {ITdoFileHandle} from '../../../models/ui/i-tdo-file-handle';
import {FileManagerService} from '../../file-manager/file-manager.service';
import {ReferralAttachmentModel} from '../../configuration/referral-configuration/models/referral-attachment.model';
import {DialogService} from '../../../services/dialog.service';
import {MatSelectionList} from '@angular/material/list';
import {CommMethodEnum} from "../../../models/enum/comm-method.enum";
import { DiscomfortLevelList } from 'src/app/constants';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
    selector: 'app-referral-portal',
    templateUrl: './referral-portal.component.html',
    styleUrls: ['./referral-portal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ReferralPortalComponent implements OnInit, OnDestroy {

    @ViewChild('otherServicesList') otherServicesList: MatSelectionList;
    @ViewChild('referralTreatmentRequestedList') referralTreatmentRequestedList: MatSelectionList;
    @ViewChild('errorCard') errorCard: ElementRef<HTMLDivElement>;


    SelfInsurance: boolean;
    token: string;
    TdoGuid: string;
    showMessage: string;
    authorizedUser: boolean;
    ReferralName: string;
    PracticeName: string;
    ReferralToDoctor: string;
    isChecked: boolean = false;
    isImageUploaded: boolean = false;
    isLoading: boolean = false;
    isMobile: boolean = false;
    isTablet: boolean = false;
    hasError: boolean = false;
    errorTitle: string = '';
    errorMessage: string = '';
    private destroy$ = new Subject<void>();


    selectedReferralSchedule: string;
    selectedReferralTreatment: string;
    selectedReferralOtherService: string;
    selectedDiscomfort: string;
    TreatmentRequestedList: string[] = [];
    OtherServicesList: string[] = [];
    selectedTeethList: string[] = [];
    files: File[] = [];


    queryModel: ReferringDoctorQueryOptionsModel;
    doctorList: TDOReferringDataDoctorModel[] = [];
    currentProvider: TDOReferringDataDoctorModel;
    ReferringDoctor: ReferringDoctorDataModel;
    ReferralData: ReferralDataModel;
    taskModel: SystemTaskDataModel;
    emailInformation: emailReferralPortalInformationModel;

    enumObjectTypeID = '00000949-1000-0000-0000-000000000009';
    enumUserTaskTypeID = '00000850-1000-0000-0000-000000000011';
    enumTaskStatusID = '00000051-1000-0000-0000-000000000001';
    enumTaskPriorityID = '00000052-1000-0000-0000-000000000001';


    /* file upload*/
    documents: ReferralAttachmentModel[] = [];
    index = 0;


    isShowPublish = false;
    labelResponseModels: LabelResponseModel[] = [];
    viewType = 'thumbnail'; // detail, gallery, pane, thumbnail
    sortType = 'user_defined';
    thumbnailImages: DocumentDataImageModel[];
    thumbnailImageSize = 150;

    ListOfUpperTeeth = [
        {id: 'A0000000-1000-0000-0000-000000000001', Notation: '1', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000002', Notation: '2', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000003', Notation: '3', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000004', Notation: '4', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000005', Notation: '5', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000006', Notation: '6', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000007', Notation: '7', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000008', Notation: '8', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000009', Notation: '9', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000010', Notation: '10', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000011', Notation: '11', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000012', Notation: '12', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000013', Notation: '13', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000014', Notation: '14', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000015', Notation: '15', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000016', Notation: '16', checked: false}];
    ListOfLowerTeeth = [
        {id: 'A0000000-1000-0000-0000-000000000017', Notation: '17', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000018', Notation: '18', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000019', Notation: '19', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000020', Notation: '20', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000021', Notation: '21', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000022', Notation: '22', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000023', Notation: '23', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000024', Notation: '24', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000025', Notation: '25', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000026', Notation: '26', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000027', Notation: '27', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000028', Notation: '28', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000029', Notation: '29', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000030', Notation: '30', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000031', Notation: '31', checked: false},
        {id: 'A0000000-1000-0000-0000-000000000032', Notation: '32', checked: false}];
        DiscomfortLevelList: any[]= DiscomfortLevelList;
    constructor(private route: ActivatedRoute,
                public apiService: ReferralsService,
                private formBuilder: FormBuilder,
                private snackBar: MatSnackBar,
                private dialogService: DialogService,
                public documentService: FileManagerService,
                private breakpointObserver: BreakpointObserver,
                private cdr: ChangeDetectorRef) {
        this.ReferringDoctor = new DataReferralDoctorsModel();
        this.ReferralData = new ReferralDataModel();
    }

    async ngOnInit(): Promise<void> {
        this.isLoading = true;
        this.token = this.route.snapshot.queryParamMap.get('token');

        // Set up responsive breakpoint observer
        this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet])
            .pipe(takeUntil(this.destroy$))
            .subscribe(result => {
                this.isMobile = this.breakpointObserver.isMatched(Breakpoints.Handset);
                this.isTablet = this.breakpointObserver.isMatched(Breakpoints.Tablet);
            });

        // Perform authentication check using the token
        if (this.token) {
            localStorage.setItem('TDOReferralPortalAuthToken', this.token);
            // Validate the token
            this.apiService.validateReferralPortalToken(this.token).pipe(takeUntil(this.destroy$)).subscribe(authResponse => {
                if (!authResponse || !authResponse.isSuccess || authResponse.TdoGuid === null) {
                    localStorage.removeItem('TDOReferralPortalAuthToken');
                    this.authorizedUser = false;
                    this.showExpiredTokenError();
                    this.isLoading = false;
                    this.cdr.detectChanges();
                    return;
                } else {
                    this.setUpPortal(authResponse);
                }
            }, () => {
                localStorage.removeItem('TDOReferralPortalAuthToken');
                this.authorizedUser = false;
                this.showExpiredTokenError();
                this.isLoading = false;
                this.cdr.detectChanges();
            });
        } else {
            // Token is missing, handle unauthorized access
            this.authorizedUser = false;
            this.showMissingTokenError();
            this.isLoading = false;
            this.cdr.detectChanges();
        }
    }

    setUpPortal(authResponse: ReferralPortalAuthenticateResponseModel) {
        this.ReferralData.DiscomfortLevel = DiscomfortLevelList[0].id;
        this.ReferralName = authResponse.ReferralClientName;
        this.PracticeName = authResponse.tdoCName;
        this.TdoGuid = authResponse.TdoGuid;
        this.queryModel = new ReferringDoctorQueryOptionsModel();
        this.queryModel.isLazyLoad = true;
        this.queryModel.ReferralEntityID = authResponse.ReferralEntityID;

        this.apiService.getDoctorsByReferralEntityID(this.token, this.TdoGuid, this.queryModel).pipe(takeUntil(this.destroy$)).subscribe(dataDoc => {
            if (dataDoc && dataDoc.length > 0) {
                this.doctorList = dataDoc;
                this.currentProvider = this.doctorList[0];
                this.ReferralData.ReferralScheduleItemID = this.currentProvider.cfgReferralSchedule?.[0]?.ReferralScheduleItemID;
                this.ReferralData.ReferralEntityDocID = this.currentProvider.ReferralEntityDocID;
                if (dataDoc.length === 1) {
                    this.ReferralToDoctor = 'Dr. ' + this.currentProvider.dataContact.FirstName + ' ' + this.currentProvider.dataContact.LastName;
                }
                this.authorizedUser = true;
            } else {
                this.showExpiredTokenError();
            }
            this.isLoading = false;
            this.cdr.detectChanges();
        }, () => {
            this.showExpiredTokenError();
            this.isLoading = false;
            this.cdr.detectChanges();
        });
    }

    showExpiredTokenError() {
        this.hasError = true;
        this.authorizedUser = false;
        this.errorTitle = 'Referral Link Expired';
        this.errorMessage = 'The referral link you are using is no longer valid. Please contact your referring office to request a new referral link.';
        this.focusErrorCard();
    }

    showMissingTokenError() {
        this.hasError = true;
        this.authorizedUser = false;
        this.errorTitle = 'Invalid Referral Link';
        this.errorMessage = 'It looks like the referral link is missing or incomplete. Please check the link you received and try again, or contact your referring office for assistance.';
        this.focusErrorCard();
    }

    private focusErrorCard() {
        // Defer focus until after Angular renders the *ngIf block
        setTimeout(() => this.errorCard?.nativeElement?.focus(), 0);
    }


    changeDr(doc, event: Event) {
        event.stopPropagation();
        this.currentProvider = doc;
        this.TreatmentRequestedList = [];
        this.OtherServicesList = [];
        this.ReferralData.ReferralScheduleItemID = this.currentProvider.cfgReferralSchedule[0].ReferralScheduleItemID;
        this.ReferralData.ReferralEntityDocID = this.currentProvider.ReferralEntityDocID;
        this.referralTreatmentRequestedList.selectedOptions.clear();
        this.otherServicesList.selectedOptions.clear();
    }

    changeReferralSchedule(event) {
        this.ReferralData.ReferralScheduleItemID = event.ReferralScheduleItemID;
    }

    changeReferralTreatment(event) {
        const index = this.TreatmentRequestedList.indexOf(event.ReferralTretmentID);
        if (index > -1) {
            this.TreatmentRequestedList.splice(index, 1); // Remove item if it exists in the array
        } else {
            this.TreatmentRequestedList.push(event.ReferralTretmentID); // Add item if it doesn't exist in the array
        }
    }

    changeReferralOtherService(event) {
        const index = this.OtherServicesList.indexOf(event.ReferralOtherID);
        if (index > -1) {
            this.OtherServicesList.splice(index, 1); // Remove item if it exists in the array
        } else {
            this.OtherServicesList.push(event.ReferralOtherID); // Add item if it doesn't exist in the array
        }
    }

    selectedUpperTeeth(event) {
        this.updateSelectedTeethList(event);
        this.ListOfUpperTeeth = this.ListOfUpperTeeth.map(item => {
            if (item.id === event.id) {
                item.checked = !item.checked;
            }
            return item;
        });
    }

    selectedLowerTeeth(event) {
        this.updateSelectedTeethList(event);
        this.ListOfLowerTeeth = this.ListOfLowerTeeth.map(item => {
            if (item.id === event.id) {
                item.checked = !item.checked;
            }
            return item;
        });
    }

    updateSelectedTeethList(event) {
        const index = this.selectedTeethList.indexOf(event.id);
        if (index > -1) {
            this.selectedTeethList.splice(index, 1); // Remove item if it exists in the array
        } else {
            this.selectedTeethList.push(event.id); // Add item if it doesn't exist in the array
        }
    }

    changeDiscomfort(event) {
        this.ReferralData.DiscomfortLevel = event.id;
    }

    async Submit() {
        this.isLoading = true;
    // All fields are valid, proceed with form submission
        this.ReferralData.ReferralOtherIDsJSON = this.OtherServicesList.join(' ');
        this.ReferralData.ReferralTretmentIDsJSON = this.TreatmentRequestedList.join(' ');
        this.ReferralData.ToothIDsJSON = this.selectedTeethList.join(' ');
        this.ReferringDoctor.Provider_DoctorID = this.currentProvider.DoctorId;

        // create FormData to upload
        const formData = new FormData();
        for (const file of this.files) {
            formData.append('files', file, file.name);
        }

        this.apiService.saveReferralDoc(this.token, this.TdoGuid, this.ReferringDoctor).subscribe(dataDoc => {
            if (dataDoc) {
                this.ReferringDoctor = dataDoc;
                this.ReferralData.RefDoctorID = this.ReferringDoctor.RefDoctorID;
                this.apiService.saveReferral(this.token, this.TdoGuid, this.ReferralData).subscribe(async response => {
                    if (response) {
                        formData.append('refid', response.ReferralID);
                        formData.append('LOCID', this.currentProvider.LOCID.toString());
                        // file upload call and Task creation
                        await this.ReferralPostSavingExecution(this.token, this.TdoGuid, formData);
                        await this.sendEmail();
                        this.isLoading = false;
                        this.dialogService.openConfirmDialog('Your referral to ' + this.getFullName(this.currentProvider) + ' was successfully sent!',
                            false, false, 'Referral Portal').subscribe((result) => {
                                this.clearForm();
                        });
                        
                    }
                }, err => {
                    console.log('err', err);
                    this.isLoading = false;
                    this.dialogService.openConfirmDialog('Your referral to ' + this.getFullName(this.currentProvider) + ' was NOT sent! Please try again! Problems encountered: ' + err.message,
                        false, false, 'Referral Portal').subscribe((result) => {
                        this.clearForm();
                    });
                });
            }
        }, err => {
            console.log('err', err);
            this.isLoading = false;
            this.snackBar.open('Error saving Information', 'Error', {
                duration: 5000,
                verticalPosition: 'top'
            });
        });
    }

    getFullName(provider: TDOReferringDataDoctorModel) {
        return (provider.Title !== null ? provider.Title + ' ' : '') + provider.dataContact.FirstName + ' ' + provider.dataContact.LastName;
    }

    clearForm() {
        this.SelfInsurance = false;
        this.OtherServicesList = [];
        this.otherServicesList.selectedOptions.clear();
        this.TreatmentRequestedList = [];
        this.referralTreatmentRequestedList.selectedOptions.clear();
        this.selectedTeethList = [];
        this.ReferralData = new ReferralDataModel();
        this.ReferralData.DiscomfortLevel = this.DiscomfortLevelList[0].id;
        this.ReferralData.ReferralScheduleItemID = this.currentProvider.cfgReferralSchedule[0].ReferralScheduleItemID;
        this.ReferralData.Patient_DOB = new Date();
        this.ReferringDoctor = new ReferringDoctorDataModel();
        this.currentProvider = this.doctorList[0];
        this.documents = [];
        this.files = [];
        this.isChecked = false;
        this.isImageUploaded = false;

        this.ListOfUpperTeeth.forEach(item => {
            item.checked = false;
        });
        this.ListOfLowerTeeth.forEach(item => {
            item.checked = false;
        });
    }

    async ReferralPostSavingExecution(token: string, TdoGuid: string, formData: FormData): Promise<void> {
        
        if (formData.getAll('files').length > 0) {
            this.isImageUploaded = true;
            await this.apiService.uploadReferralPortalDocuments(this.token, this.TdoGuid, formData).toPromise();
        }
        this.taskModel = this.createTask(formData);
        await this.apiService.saveReferralPortalTask(this.token, this.TdoGuid, this.taskModel).toPromise();
    }

    async sendEmail() {
        this.emailInformation = new emailReferralPortalInformationModel();
        this.emailInformation.toReferringDocEmailAddress = this.ReferringDoctor.email;
        this.emailInformation.referringDoctor = this.ReferringDoctor.FullName;
        this.emailInformation.toReferralDocEmailAddress = this.currentProvider.dataContact.dataContactComms.find(x => x.enumCommMethodID === CommMethodEnum.Email) !== undefined ? 
                                                            this.currentProvider.dataContact.dataContactComms.find(x => x.enumCommMethodID === CommMethodEnum.Email && x.isPreferred === true) !== undefined ? 
                                                            this.currentProvider.dataContact.dataContactComms.find(x => x.enumCommMethodID === CommMethodEnum.Email && x.isPreferred === true).Address : 
                                                            this.currentProvider.dataContact.dataContactComms.find(x => x.enumCommMethodID === CommMethodEnum.Email).Address : '';
        this.emailInformation.referralDoctorContactName = this.getFullName(this.currentProvider);
        this.emailInformation.patientFullName = this.ReferralData.Patient_FirstName + ' ' + this.ReferralData.Patient_LastName;
        this.emailInformation.teethInformation = this.getTeeth();
        this.emailInformation.isImageUploaded = this.isImageUploaded;
      this.apiService.sendReferralPortalEmail(this.token, this.TdoGuid, this.emailInformation).subscribe();
    }

    getTeeth() {
        let teethList: string = '';
        let teeth: string[] = [];
        teeth = this.ReferralData.ToothIDsJSON.split(' ');
        for (let i = 0; i < teeth.length; i++) {
            if (this.ListOfUpperTeeth.find(x => x.id === teeth[i])) {
                teethList = teethList + ',' + this.ListOfUpperTeeth.find(x => x.id === teeth[i]).Notation;
            } else if (this.ListOfLowerTeeth.find(x => x.id === teeth[i])) {
                teethList = teethList + ',' + this.ListOfLowerTeeth.find(x => x.id === teeth[i]).Notation;
            }
        }
        return teethList.substring(1);
    }

    getDate(d: any) {
        return new Date(d);
    }

    SelfChecked(event: Event) {
        if (this.SelfInsurance) {
            this.ReferralData.Insurance_FirstName = this.ReferralData.Patient_FirstName;
            this.ReferralData.Insurance_LastName = this.ReferralData.Patient_LastName;
            this.ReferralData.Insurance_DOB = this.getDate(this.ReferralData.Patient_DOB);
        } else {
            this.ReferralData.Insurance_FirstName = '';
            this.ReferralData.Insurance_LastName = '';
            this.ReferralData.Insurance_DOB = this.getDate(Date);
        }
    }

    CheckIfSaveDisabled() {
        return (!this.ReferringDoctor.FullName || this.ReferringDoctor.FullName.length === 0) ||
      (!this.ReferringDoctor.email || this.ReferringDoctor.email.length === 0) ||
      (!this.ReferringDoctor.phone || this.ReferringDoctor.phone.length === 0) ||
      (!this.ReferralData.ReferralScheduleItemID || this.ReferralData.ReferralScheduleItemID === '') ||
      (!this.selectedTeethList || this.selectedTeethList.length < 1) ||
      (!this.TreatmentRequestedList || this.TreatmentRequestedList.length < 1);
    }

    createTask(formData: FormData) {
        const task = new SystemTaskDataModel();
        task.LOCID = this.currentProvider.LOCID;
        task.ObjectId = this.queryModel.ReferralEntityID;
        task.enumObjectTypeID = this.enumObjectTypeID;
        task.isSystem = false;
        task.enumSystemTaskID = null;
        task.enumUserTaskTypeID = this.enumUserTaskTypeID;
        task.ForUserGroupID = null;
        task.ForUserID = null;
        task.AssignedToUserID = null;
        task.enumTaskStatusID = this.enumTaskStatusID;
        task.enumTaskPriorityID = this.enumTaskPriorityID;
        task.DueDate = new Date();
        task.Description = 'Process Referral to schedule appointment RE:' + this.ReferralData.Patient_FirstName + ' ' + this.ReferralData.Patient_LastName;
        task.ContentParametersJSON = `{"Subject": "Process Referral", "DueDateReference":"", "Notes": " ${this.ReferralData.Notes}", "PatientName": " ${this.ReferralData.Patient_FirstName} ${this.ReferralData.Patient_LastName}", "ReferralID" : "${formData.get('refid').toString()}"}`;
        return task;
    }


    onFilesDropped(event: ITdoFileHandle[]) {
        event.forEach(fileDropped => {
            console.log('dropped file', fileDropped);
            this.files.push(fileDropped.file);
            this.uploadDocuments(fileDropped.file);
        });
    }


    uploadDocuments(file: File) {
        const newfile = new ReferralAttachmentModel();
        newfile.Description = file.name;
        this.documents.push(newfile);
    }

    DeleteFile(item: ReferralAttachmentModel) {
        const index = this.documents.indexOf(item);
        if (index > -1) {
            this.documents.splice(index, 1);
        }
        const indexFile = this.files.findIndex(x => x.name === item.Description);
        if (indexFile > -1) {
            this.files.splice(indexFile, 1);
        }
    }

    getDocumentTypeFromUrl(mod: ReferralAttachmentModel): string {
        if (!mod) {
            return;
        }
        const extension = mod.Description.split('.').pop().toLowerCase();
        if (extension === 'png' || extension === 'jpeg' || extension === 'jpg') {
            return '../../../assets/icons/icons8-photo-gallery.svg';
        } else if (extension === 'xlsx' || extension === 'xls') {
            return '../../../assets/Images/image-organizer/thumbnail/excel_white.svg';
        } else if (extension === 'pdf') {
            return '../../../assets/Images/image-organizer/thumbnail/picture_as_pdf_white_24dp.svg';
        } else if (extension === 'docx' || extension === 'doc') {
            return '../../../assets/Images/image-organizer/thumbnail/word_white.svg';
        } else if (extension === 'pptx' || extension === 'ppt') {
            return '../../../assets/Images/image-organizer/thumbnail/powerpoint_white.svg';
        } else {
            return '../../../assets/icons/icons8-note.svg';
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
